import { StyleSheet, Text, View } from 'react-native'
import React from 'react'
import { ThemedView } from '@app/theme'
import PageLoader from '@app/sharedComponents/PageLoader/PageLoader'

const PaymentLoader = () => {
  return (
    <PageLoader />
  )
}

export default PaymentLoader
